import _typeof from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/typeof.js";
import _asyncToGenerator from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.regexp.replace.js";
import * as Mousetrap from 'mousetrap';
export default /*#__PURE__*/(function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            context.Vue.prototype.$keyboard = {
              is_pressed: {
                shift: false
              },
              init: function init() {
                context.Vue.prototype.$keyboard.bindKeyTrigger('esc');
                context.Vue.prototype.$keyboard.bindKeyTrigger('enter');
                context.Vue.prototype.$keyboard.bindKeyTrigger('alt+enter');
                context.Vue.prototype.$keyboard.bindKeyTrigger('shift+alt+enter');
                context.Vue.prototype.$keyboard.bindKeyTrigger('shift+enter');
                context.Vue.prototype.$keyboard.bindKeyTrigger('left');
                context.Vue.prototype.$keyboard.bindKeyTrigger('right'); // helper keys

                Mousetrap.bind('shift', function () {
                  context.Vue.prototype.$keyboard.is_pressed.shift = true;
                }, 'keydown').bind('shift', function () {
                  context.Vue.prototype.$keyboard.is_pressed.shift = false;
                }, 'keyup');
              },
              bindKeyTrigger: function bindKeyTrigger(key) {
                key = key.replace(/\+/, '_');

                if (_typeof(context.Vue.prototype.$keyboard.helper[key]) === 'object') {
                  Mousetrap.bind(key, function (params) {
                    context.Vue.prototype.$keyboard.helper.trigger(key, params);
                  });
                }
              },
              bind: function bind(keyCombo, callback, eventType) {
                if (typeof eventType === 'string') {
                  Mousetrap.bind(keyCombo, callback, eventType);
                } else {
                  Mousetrap.bind(keyCombo, callback);
                }
              },
              helper: {
                esc: {
                  _: {
                    stack: []
                  }
                },
                enter: {
                  _: {
                    stack: []
                  }
                },
                alt_enter: {
                  _: {
                    stack: []
                  }
                },
                shift_alt_enter: {
                  _: {
                    stack: []
                  }
                },
                shift_enter: {
                  _: {
                    stack: []
                  }
                },
                left: {
                  _: {
                    stack: []
                  }
                },
                right: {
                  _: {
                    stack: []
                  }
                },
                push: function push(key, id, callback) {
                  if (typeof id !== 'undefined' && typeof callback === 'function') {
                    context.Vue.prototype.$keyboard.helper[key].stack.push({
                      id: id,
                      callback: callback
                    });
                  }
                },
                pop: function pop(key, id) {
                  if (typeof id !== 'undefined') {
                    var stack = context.Vue.prototype.$keyboard.helper[key]._.stack;

                    for (var i = 0, len = stack.length; i < len; i++) {
                      if (_typeof(stack[i]) === 'object' && stack[i].id === id) {
                        context.Vue.prototype.$keyboard.helper[key].stack.splice(i, 1);
                        break;
                      }
                    }
                  }
                },
                trigger: function trigger(key, params) {
                  var option = null;

                  if (key === 'esc') {
                    if (context.Vue.prototype.$keyboard.helper.esc._.stack.length > 0) {
                      option = context.Vue.prototype.$keyboard.helper.esc.stack.pop();
                    }
                  } else {
                    var stack = context.Vue.prototype.$keyboard.helper[key]._.stack;

                    for (var i = 0, len = stack.length; i < len; i++) {
                      if (_typeof(stack[i]) === 'object' && stack[i].callback === 'function') {
                        if (params.target.localName === 'textarea') {
                          params.target.preventDefault();
                        }

                        option = stack[i];
                      }
                    }
                  }

                  if (option) {
                    option.callback();
                  }
                }
              }
            };

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
})();